import axios from "axios";

const baseUrl = (state) =>
  `${process.env.REACT_APP_API_BASE_URL}api/projects/${
    process.env.REACT_APP_OVERRIDE_PROJECT_ID || state.project?.id
  }/`;

// Resolve the parent page URL when embedded in an iframe.
// document.referrer contains the parent URL; fall back to the project's own origin.
const getParentOrigin = (state) => {
  try {
    if (document.referrer) {
      const { origin } = new URL(document.referrer);
      return origin;
    }
  } catch (_) {}
  return state.project?.website || window.location.origin;
};

const api = {
  fetchProjectDetails: () => async (dispatch, getState) => {
    let host = window.location.host;
    // let host = 'kinley.com.au';
    const urlParams = new URLSearchParams(window.location.search);
    const projectId = urlParams.get("project");
    let url = `${process.env.REACT_APP_API_BASE_URL}api/projects/?hostname=${host}`;
    if (process.env.REACT_APP_OVERRIDE_PROJECT_ID)
      url = baseUrl(getState())
    else if (projectId)
      url = `${process.env.REACT_APP_API_BASE_URL}api/projects/${projectId}`

    return await axios.get(url);
  },
  fetchLots: () => async (dispatch, getState) => {
    return await axios.get(baseUrl(getState()) + "lots-geo");
  },
  fetchStages: () => async (dispatch, getState) => {
    return await axios.get(baseUrl(getState()) + "stages");
  },
  fetchHouses: () => async (dispatch, getState) => {
    return await axios.get(baseUrl(getState()) + "packages-enabled");
  },
  fetchBuilders: () => async (dispatch, getState) => {
    return await axios.get(baseUrl(getState()) + "builder");
  },
  postEnquireForm: (data) => async (dispatch, getState) => {
    const {
      email,
      firstName,
      mobilePhone,
      postcode,
      lastName,
      buyerType,
      howDidYouHearAboutUs,
      packageId,
      lotId,
      captchaToken
    } = data;
    const headers = { 'X-Parent-Origin': getParentOrigin(getState()) };
    return await axios.post(baseUrl(getState()) + "enquire", {
      email,
      firstName,
      lastName,
      mobilePhone,
      postcode,
      buyerType,
      howDidYouHearAboutUs,
      lotId,
      packageId,
      captchaToken
    }, { headers });
  },
  postRegistrationForm: (data) => async (dispatch, getState) => {
    const {
      email,
      firstName,
      mobilePhone,
      postcode,
      lastName,
      buyerType,
      howDidYouHearAboutUs,
      captchaToken
    } = data;
    const headers = { 'X-Parent-Origin': getParentOrigin(getState()) };
    return axios
      .post(baseUrl(getState()) + 'register', {
        email,
        firstName,
        lastName,
        mobilePhone,
        postCode: postcode,
        buyerType,
        howDidYouHearAboutUs,
        skipRedirect: true,
        captchaToken
      }, { headers });
  },    
};
export default api;
